/**
 * Created by shobhitjain on 27/12/19.
 */

import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import style from './index.scss';

/**
 * CollapsibleComponent
 */
class CollapsibleComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chevronUp: false
    };
  }

  /**
   * toggleTable
   */
  toggleTable = () => {
    this.setState({ chevronUp: !this.state.chevronUp }, () => {
      this.props.isExpanded(this.props.index);
    });
  };

  /**
   * Render func
   * @returns {*}
   */
  render() {
    const { chevronUp } = this.state;
    const { title, data, header } = this.props;
    return (
      <tr style={{ padding: 0, margin: 0 }}>
        <td className={style.zeroPadMar} colSpan="21">
          <div className={classnames(style.card)}>
            <div
              onClick={this.toggleTable}
              className={classnames(
                style.card_header,
                'd-flex',
                'align-items-center',
                chevronUp ? style.border_radius_bottom_zero : ''
              )}
              style={{ cursor: 'pointer' }}>
              <div>
                <span>{title}</span>
              </div>
              <i
                className={classnames(
                  'icon14',
                  chevronUp ? 'icon14_icon_arrow_up' : 'icon14_icon_arrow_down',
                  'ml-auto'
                )}
                aria-hidden="true"
              />
            </div>
            {chevronUp && (
              <div className={style.collapsed} id="collapseExample">
                <div
                  className={classnames(
                    style.card_body,
                    'p-0',
                    data.length > 0 ? style.height_class : ''
                  )}>
                  {this.props.children}
                </div>
              </div>
            )}
          </div>
        </td>
      </tr>
    );
  }
}

/**
 * Proptypes
 * @type {{data: shim, index: shim, title: shim}}
 */
CollapsibleComponent.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  index: PropTypes.number.isRequired
};

/**
 * Default props
 * @type {{data: []}}
 */
CollapsibleComponent.defaultProps = {
  data: []
};

export default CollapsibleComponent;
